export default __webpack_public_path__ + "static/media/silverClass.1b928c0f.png";